import request from './api'
import {getYm} from "../utils/date.utils";

function adaptObjectsToTree(rows) {
    if (!Array.isArray(rows)) return []
    return rows.map((row) => ({
        id: `_${String(row.kod_numobj)}`,
        t: row.text || `ЭО№${row.num_obj}: ${row.name || ''}`.trim(),
        pId: null,
        isG: false,
        askue: 0,
        fias: row.id_fias ?? null,
    }))
}

export async function getObjects(kod_dog) {
    try {
        const res = await request('/api/range-volumes/objects','POST',{kod_dog})
        return {
            isOk: true,
            data: adaptObjectsToTree(res)
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
/*{
    "kod_dog": 123456,
    "search": "ул. Ленина"
}*/
/*[
    {
        "kod_numobj": 0,
        "kod_obj": 0,
        "num_obj": 0,
        "name": "string",
        "adr": "string",
        "kod_vidkommun": 0
    }
]*/

export async function getData(kod_dog, kod_numobjs) {
    try {
        const res = await request('/api/range-volumes/data','POST',{kod_dog, kod_numobjs})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        // TODO: убрать mock, когда API /range-volumes/data стабильно ответит
        const rows = Array.from({ length: 5 }, (_, i) => ({
            id: i + 1,
            kod_numobj: 1001 + i,
            kod_obj: 2001 + i,
            num_obj: i + 1,
            name: `Объект ${i + 1}`,
            adr: `ул. Тестовая, д. ${i + 1}`,
            col5_vol_total: (i + 1) * 100,
            col6_ls_d1: (i + 1) * 2,
            col7_vol_d1: (i + 1) * 10,
            col8_vol_odn_d1: (i + 1) * 3,
            col9_ls_md_d1: i,
            col10_vol_md_d1: i * 5,
            col11_ls_d2: (i + 1),
            col12_vol_d2: (i + 1) * 7,
            col13_ls_d3: Math.max(0, i - 1),
            col14_vol_d3: Math.max(0, i - 1) * 4,
            t_sent: new Date().toISOString()
        }))
        return {
            isOk: true,
            isMock: true,
            message: e.message,
            data: {
                rows
            }
        }
    }
}
/*
{
    "kod_dog": 123456,
    "ym": 202607,
    "kod_numobj_list": [
    1001,
    1002
]
}*/
/*
{
    "ym": 202607,
    "rows": [
    {
        "kod_numobj": 0,
        "kod_obj": 0,
        "num_obj": 0,
        "name": "string",
        "adr": "string",
        "col5_vol_total": 0,
        "col6_ls_d1": 0,
        "col7_vol_d1": 0,
        "col8_vol_odn_d1": 0,
        "col9_ls_md_d1": 0,
        "col10_vol_md_d1": 0,
        "col11_ls_d2": 0,
        "col12_vol_d2": 0,
        "col13_ls_d3": 0,
        "col14_vol_d3": 0,
        "t_sent": "2026-07-31T13:58:13.121Z"
    }
]
}*/

export async function saveData(kod_dog, Ndog, rows) {
    try {
        const res = await request('/api/range-volumes/save','POST',{kod_dog, Ndog, rows})
        return {
            isOk: true,
            message: res.message
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function uploadExcel(formData) {
    try {
        const data = await request(
            '/api/range-volumes/upload-excel',
            'PUT',
            formData,
            'multipart'
        )
        return {
            isOk: true,
            message: data.message,
            data
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

/*{
    "kod_dog": 123456,
    "Ndog": "123/456",
    "rows": [
    {
        "kod_numobj": 0,
        "col6_ls_d1": 0,
        "col7_vol_d1": 0,
        "col8_vol_odn_d1": 0,
        "col9_ls_md_d1": 0,
        "col10_vol_md_d1": 0,
        "col11_ls_d2": 0,
        "col12_vol_d2": 0,
        "col13_ls_d3": 0,
        "col14_vol_d3": 0
    }
]
}*/
/*{
    "status": true,
    "message": "Объёмы по диапазонам переданы",
    "saved": 1,
    "filename": "1650123456_165001001_21_07_2026_10_41.csv",
    "queue_id": "string"
}*/

export async function getHistory(kod_dog, kod_numobjs, periodStart, periodEnd) {
    try {
        const ym_from = getYm(periodStart)
        const ym_to = getYm(periodEnd)
        const res = await request('/api/range-volumes/history','POST',{kod_dog, kod_numobjs, ym_from, ym_to})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
/*
{
    "kod_dog": 123456,
    "kod_numobj_list": [
    1001,
    1002
],
    "ym_from": 202601,
    "ym_to": 202607
}*/
/*
[
    {
        "ym": 202607,
        "kod_numobj": 0,
        "kod_obj": 0,
        "num_obj": 0,
        "name": "string",
        "adr": "string",
        "col5_vol_total": 0,
        "col6_ls_d1": 0,
        "col7_vol_d1": 0,
        "col8_vol_odn_d1": 0,
        "col9_ls_md_d1": 0,
        "col10_vol_md_d1": 0,
        "col11_ls_d2": 0,
        "col12_vol_d2": 0,
        "col13_ls_d3": 0,
        "col14_vol_d3": 0,
        "t_sent": "2026-07-31T14:07:26.112Z"
    }
]*/

export async function getBlankExcel(kod_dog, ym, kod_numobjs){
    try {
        const res = await request('/api/range-volumes/blank-excel', 'POST', {kod_dog, ym, kod_numobjs})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
/*{
    "kod_dog": 123456,
    "ym": 202607,
    "kod_numobj_list": [
    1001,
    1002
]
}*/
